const SET_CONG_VIEC_PAGING = (state, congViecPaging) => {
  state.congViecPaging = congViecPaging;
};
const SET_DANH_SACH_CONG_VIEC = (state, danhSachCongViec) => {
  state.danhSachCongViec = danhSachCongViec;
};
const SET_DANH_SACH_CONG_VIEC_LIEN_QUAN = (state, danhSachCongViecLQ) => {
  state.danhSachCongViecLQ = danhSachCongViecLQ;
};
const SET_DANH_SACH_TRANG_THAI_CONG_VIEC = (state, danhSachTrangThaiCv) => {
  state.danhSachTrangThaiCv = danhSachTrangThaiCv;
};
const SET_DANH_SACH_TAO_CONG_VIEC = (state, danhSachDonViTaoCongViec) => {
  state.danhSachDonViTaoCongViec = danhSachDonViTaoCongViec;
};
const SET_DANH_SACH_GAN_CONG_VIEC = (state, danhSachDonViGanCongViec) => {
  state.danhSachDonViGanCongViec = danhSachDonViGanCongViec;
};
const SET_CHI_TIET_CONG_VIEC = (state, chiTietCongViec) => {
  state.chiTietCongViec = chiTietCongViec;
};
const SET_DANH_SACH_LICH_SU_GIAO_VIEC = (state, danhSachLichSuGiaoViec) => {
  state.danhSachLichSuGiaoViec = danhSachLichSuGiaoViec;
};

const SET_DANH_SACH_MUC_DO_CONG_VIEC = (state, danhSachMucDoCongViec) => {
  state.danhSachMucDoCongViec = danhSachMucDoCongViec;
};
const SET_DANH_SACH_LICH_SU_THAY_DOI_TRANG_THAI_CONG_VIEC = (
  state,
  danhSachLichSuThayDoiTrangThaiCongViec
) => {
  state.danhSachLichSuThayDoiTrangThaiCongViec = danhSachLichSuThayDoiTrangThaiCongViec;
};
const SET_DANH_SACH_COT_CONG_VIEC = (state, danhSachHienThiCotCongViec) => {
  state.danhSachHienThiCotCongViec = danhSachHienThiCotCongViec;
};
const CAP_NHAT_DANH_SACH_COT_CONG_VIEC = (
  state,
  danhSachHienThiCotCongViecCapNhat
) => {
  state.danhSachHienThiCotCongViecCapNhat = danhSachHienThiCotCongViecCapNhat;
};
const SET_DANH_SACH_LICH_SU_DON_DOC_CONG_VIEC = (state, danhSachLichSuDonDocCongViec) => {
  state.danhSachLichSuDonDocCongViec = danhSachLichSuDonDocCongViec;
};

export default {
  SET_CONG_VIEC_PAGING,
  SET_DANH_SACH_CONG_VIEC,
  SET_DANH_SACH_TRANG_THAI_CONG_VIEC,
  SET_DANH_SACH_TAO_CONG_VIEC,
  SET_DANH_SACH_GAN_CONG_VIEC,
  SET_CHI_TIET_CONG_VIEC,
  SET_DANH_SACH_CONG_VIEC_LIEN_QUAN,
  SET_DANH_SACH_LICH_SU_GIAO_VIEC,
  SET_DANH_SACH_MUC_DO_CONG_VIEC,
  SET_DANH_SACH_LICH_SU_THAY_DOI_TRANG_THAI_CONG_VIEC,
  SET_DANH_SACH_COT_CONG_VIEC,
  CAP_NHAT_DANH_SACH_COT_CONG_VIEC,
  SET_DANH_SACH_LICH_SU_DON_DOC_CONG_VIEC
};
